// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, func, string } from 'prop-types'
import { Field } from 'redux-form'
import { AutoSuggest } from 'components/Form'
import { LoadingIcon } from 'components'

class StaticAutoSuggest extends React.Component {
  static propTypes = {
    autoFocus: bool,
    fetchSuggestions: func.isRequired,
    handleSelection: func.isRequired,
    idRoot: string.isRequired,
    label: string,
    name: string.isRequired,
    optionKey: string,
    renderSuggestionsContainer: func,
  }

  state = {
    entities: [],
    error: '',
    loading: true,
  }

  async componentDidMount () {
    const { emptyResultsError, fetchSuggestions } = this.props
    const loading = false
    try {
      const { entities } = await fetchSuggestions()
      const error = !entities.length ? emptyResultsError : ''
      this.setState(() => ({ entities, error, loading }))
    } catch (err) {
      console.warn(err)
      this.setState(() => ({ error: err.message, loading }))
    }
  }

  render () {
    const {
      props,
      state: { entities, error, loading },
    } = this

    const {
      autoFocus,
      handleSelection,
      idRoot,
      label,
      name,
      optionKey,
      renderSuggestionsContainer,
    } = props

    const fieldNode = (
      !loading
        ? (
          <Field
            alwaysRenderSuggestions={true}
            autoFocus={autoFocus}
            component={AutoSuggest}
            handleSelection={handleSelection}
            id={`${idRoot}-antenna-company`}
            label={label}
            name={name}
            optionKey={optionKey}
            renderSuggestionsContainer={renderSuggestionsContainer}
            staticSuggestions={entities} />
        )
        : <LoadingIcon loading={loading} />
    )

    return (
      <div>
        {fieldNode}
        {error && <p className={'error-message'}>{error}</p>}
      </div>
    )
  }
}
export default StaticAutoSuggest
